import { useContrastQuery } from '../../hooks/use-contrast-query'
import { Query } from '../../hooks/queries'
import { HTTPError } from '../../api/fetch/decorate-fetch'
import {
  GetOrganizationSettingsArgs,
  GetOrganizationSettingsResponse,
  getOrganizationSettings
} from './api/requests/get-organization-settings'

export interface UseOrganizationSettingsQueryProps {
  organizationUuid: string
}

export interface GetOrganizationSettingsQueryResponse {
  data: GetOrganizationSettingsResponse | undefined
  error: HTTPError | null
  isError: boolean
  isLoading: boolean
}

export type UseOrganizationSettingsQuery = (
  props: UseOrganizationSettingsQueryProps
) => GetOrganizationSettingsQueryResponse

export const useOrganizationSettingsQuery: UseOrganizationSettingsQuery = ({
  organizationUuid
}: UseOrganizationSettingsQueryProps) => {
  const { data, error, isError, isLoading } = useContrastQuery<
    GetOrganizationSettingsArgs,
    GetOrganizationSettingsResponse
  >([Query.ORGANIZATION_SETTINGS, organizationUuid], getOrganizationSettings, {
    organizationUuid
  })

  return {
    data,
    error,
    isError,
    isLoading
  }
}
